interface FinishContent {
  title: string;
  messages: {
    success: string;
    instructions: string;
    highlight: string;
  };
}

export const finishContent: FinishContent = {
  title: "Pedido Enviado com Sucesso!",
  messages: {
    success: "Ótimo! Recebemos seu pedido e nossos especialistas já começaram a análise dos seus arquivos.",
    instructions: "Em breve você receberá um e-mail com a confirmação do pedido e o link para realizar o pagamento, caso todos os arquivos estejam dentro dos nossos padrões de qualidade para impressão.",
    highlight: "Fique de olho na sua caixa de entrada!"
  }
}; 